import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete, { AutocompleteRenderOptionState } from '@material-ui/lab/Autocomplete';

type InputProps = {
  label?: string;
  value: string;
  options: Array<SelectOption<string>>;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  className?: string;
  error?: boolean;
  helperText?: string;
  renderOption?: (
    option: SelectOption<string>,
    state: AutocompleteRenderOptionState,
  ) => React.ReactNode;
  disableClearable?: boolean;
  textFieldClassName?: string;
  disabled?: boolean;
  dataCy?: string;
};

export const UiAutocomplete = ({
  label,
  value,
  options,
  className,
  onChange,
  autoFocus,
  error,
  helperText,
  renderOption,
  disableClearable,
  textFieldClassName,
  disabled,
  dataCy,
}: InputProps) => {
  const handleChange = (_e: React.ChangeEvent<{}>, option: SelectOption<string> | null) => {
    onChange(option ? option.value : '');
  };

  const selectedOption = options.find((o) => o.value === value) || null;

  return (
    <Autocomplete
      className={className}
      blurOnSelect
      autoHighlight
      openOnFocus
      groupBy={(o) => o.groupBy || ''}
      options={options}
      onChange={handleChange}
      getOptionLabel={(o) => o.label}
      value={selectedOption}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="dense"
          variant="outlined"
          autoFocus={autoFocus}
          error={error}
          helperText={helperText}
          className={textFieldClassName || ''}
        />
      )}
      renderOption={renderOption}
      disableClearable={disableClearable}
      disabled={disabled}
      data-cy={dataCy}
    />
  );
};
